module.exports = __webpack_public_path__ + "img/banner1.dc0c9619.png";